import Vue from 'vue'
import {HTTP} from '@/utils/httpCommonUtil';
import {BallPulseLoader} from 'vue-loaders';
import VueSimpleSpinner from 'vue-simple-spinner'
import HttpMixin from '@/mixins/HttpMixin';
import {getRestParamErrorMessage, getRestResponseErrorMessage} from '@/utils/serverErrorMessageUtil';
import {ChecklistType} from '@/enums/ChecklistType';

const typeMap = new Map<number, any>();

export default Vue.component('facility-checklist-card', {
  name: 'FacilityChecklistCard',
  props: {
    'facilityId': { type: [Number, String]}
  },
  data () {
    return {
      cardExpanded: false,
      checklistItems: [],
      facilityChecklistItems: [] as any[],
    }
  },
  components: {
    BallPulseLoader,
    VueSimpleSpinner
  },
  mixins: [ HttpMixin ],
  computed: {
    isAdding(): boolean {
      return this.facilityChecklistItems.some((item: any) => item.isNew);
    }
  },
  filters: {
    checklistTypeName(id: string): string {
      const type = typeMap.get(parseInt(id, 10));
      return type ? type.title : '';
    }
  },
  methods: {
    async expandCard () {
      this.cardExpanded = !this.cardExpanded;
      if (this.cardExpanded) {
        await this.getChecklistItems();
        await this.getFacilityChecklistItems();
      }
    },
    async getChecklistItems() {
      const items = await (this as any).httpGet('/checklist-items', 'Error while retrieving Checklist Items') || [];
      typeMap.clear();
      this.checklistItems = items.filter((item: any) => item.id !== ChecklistType.SHIFT_RECEIPTS_RECEIVED);
      this.checklistItems.forEach((item: any) => {
        typeMap.set(item.id, item);
      });
    },
    async getFacilityChecklistItems() {
      this.facilityChecklistItems = await (this as any).httpGet(`/facilities/${this.facilityId}/checklist-items`, 'Error while retrieving Checklist Items') || [];
      this.facilityChecklistItems.forEach((item: any) => {
        item.isUpdating = false;
      });
    },
    toggleEdit(item: any) {
      // noinspection SillyAssignmentJS This is necessary for Vue to know an array child changed
      this.facilityChecklistItems = this.facilityChecklistItems.filter(item => !item.isNew);
      this.facilityChecklistItems.forEach(item => item.isEditing = false);
      item.isEditing = !item.isEditing;
    },
    addItem() {
      this.facilityChecklistItems.forEach(item => item.isEditing = false);
      this.facilityChecklistItems.push({
        checklistTypeId: 0,
        isEditing: true,
        isDeleting: false,
        isSaving: false,
        isNew: true
      });
    },
    async save(item: any) {
      try {
        item.isSaving = true;
        item.typeErrorMessage = '';
        item.noteErrorMessage = '';
        const url = `/api/facilities/${this.facilityId}/checklist-items`;
        if (item.id) {
          await HTTP.put(url + `/${item.id}`, item);
        } else {
          await HTTP.post(url, item);
        }
        await this.getFacilityChecklistItems();
      } catch (err) {
        item.typeErrorMessage = getRestParamErrorMessage(err, 'checklistTypeId');
        item.noteErrorMessage = getRestParamErrorMessage(err, 'note');
        if (!item.typeErrorMessage && !item.noteErrorMessage) {
          this.$notify({
            group: 'main',
            type: 'error',
            title: 'Error',
            text: getRestResponseErrorMessage(err) || 'Error saving Checklist Item.'
          });
        }
      } finally {
        item.isSaving = false;
      }
    },
    cancel() {
      this.facilityChecklistItems = this.facilityChecklistItems.filter(item => !item.isNew);
      this.facilityChecklistItems.forEach(item => item.isEditing = false);
    },
    async deleteItem(item: any) {
      await (this as any).httpDelete(`/facilities/${this.facilityId}/checklist-items/${item.id}`, 'Error deleting Checklist Item.');
      this.facilityChecklistItems = this.facilityChecklistItems.filter(current => current.id !== item.id);
    }
  }
})



// WEBPACK FOOTER //
// ./src/components/facility/cards/checklist/FacilityChecklistCard.ts